webpackJsonp([35783957827783],{

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(119);

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(8);
	var settle = __webpack_require__(125);
	var buildURL = __webpack_require__(128);
	var parseHeaders = __webpack_require__(134);
	var isURLSameOrigin = __webpack_require__(132);
	var createError = __webpack_require__(71);
	var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(127);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	    var loadEvent = 'onreadystatechange';
	    var xDomain = false;
	
	    // For IE 8/9 CORS support
	    // Only supports POST and GET calls and doesn't returns the response headers.
	    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
	    if (("production") !== 'test' &&
	        typeof window !== 'undefined' &&
	        window.XDomainRequest && !('withCredentials' in request) &&
	        !isURLSameOrigin(config.url)) {
	      request = new window.XDomainRequest();
	      loadEvent = 'onload';
	      xDomain = true;
	      request.onprogress = function handleProgress() {};
	      request.ontimeout = function handleTimeout() {};
	    }
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request[loadEvent] = function handleLoad() {
	      if (!request || (request.readyState !== 4 && !xDomain)) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
	        status: request.status === 1223 ? 204 : request.status,
	        statusText: request.status === 1223 ? 'No Content' : request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(130);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
	        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
	        if (config.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(8);
	var bind = __webpack_require__(72);
	var Axios = __webpack_require__(121);
	var defaults = __webpack_require__(39);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(69);
	axios.CancelToken = __webpack_require__(120);
	axios.isCancel = __webpack_require__(70);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(135);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ }),

/***/ 69:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(69);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ }),

/***/ 70:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(39);
	var utils = __webpack_require__(8);
	var InterceptorManager = __webpack_require__(122);
	var dispatchRequest = __webpack_require__(123);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
	  config.method = config.method.toLowerCase();
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ }),

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(8);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(124);
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};


/***/ }),

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(8);
	var transformData = __webpack_require__(126);
	var isCancel = __webpack_require__(70);
	var defaults = __webpack_require__(39);
	var isAbsoluteURL = __webpack_require__(131);
	var combineURLs = __webpack_require__(129);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ }),

/***/ 124:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, request, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.request = request;
	  error.response = response;
	  return error;
	};


/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(71);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};


/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(8);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(8);
	var normalizeHeaderName = __webpack_require__(133);
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(68);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(68);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  /**
	   * A timeout in milliseconds to abort a request. If set to 0 (default) a
	   * timeout is not created.
	   */
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(67)))

/***/ }),

/***/ 72:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ }),

/***/ 127:
/***/ (function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function E() {
	  this.message = 'String contains an invalid character';
	}
	E.prototype = new Error;
	E.prototype.code = 5;
	E.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new E();
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(8);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      } else {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ }),

/***/ 129:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};


/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(8);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ }),

/***/ 131:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(8);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ }),

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(8);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(8);
	
	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	
	  return parsed;
	};


/***/ }),

/***/ 135:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(72);
	var isBuffer = __webpack_require__(151);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object') {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};


/***/ }),

/***/ 725:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(727);
	var isArguments = __webpack_require__(726);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 726:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 727:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 753:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(49);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (l) {
	          if (l[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              io.unobserve(l[0]);
	              l[1]();
	            }
	          }
	        });
	      });
	    }, { rootMargin: "200px" });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  getIO().observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var noscriptImg = function noscriptImg(props) {
	  // Check if prop exists before adding each attribute to the string output below to prevent
	  // HTML validation issues caused by empty values like width="" and height=""
	  var src = props.src ? "src=\"" + props.src + "\" " : "src=\"\" "; // required attribute
	  var srcSet = props.srcSet ? "srcset=\"" + props.srcSet + "\" " : "";
	  var sizes = props.sizes ? "sizes=\"" + props.sizes + "\" " : "";
	  var title = props.title ? "title=\"" + props.title + "\" " : "";
	  var alt = props.alt ? "alt=\"" + props.alt + "\" " : "alt=\"\" "; // required attribute
	  var width = props.width ? "width=\"" + props.width + "\" " : "";
	  var height = props.height ? "height=\"" + props.height + "\" " : "";
	  var opacity = props.opacity ? props.opacity : "1";
	  var transitionDelay = props.transitionDelay ? props.transitionDelay : "0.5s";
	
	  return "<img " + width + height + src + srcSet + alt + title + sizes + "style=\"position:absolute;top:0;left:0;transition:opacity 0.5s;transition-delay:" + transitionDelay + ";opacity:" + opacity + ";width:100%;height:100%;object-fit:cover;object-position:center\"/>";
	};
	
	var Img = function Img(props) {
	  var style = props.style,
	      onLoad = props.onLoad,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["style", "onLoad"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: (0, _extends3.default)({
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }, style)
	  }));
	};
	
	Img.propTypes = {
	  style: _propTypes2.default.object,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        _convertProps$imgStyl = _convertProps.imgStyle,
	        imgStyle = _convertProps$imgStyl === undefined ? {} : _convertProps$imgStyl,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor,
	        Tag = _convertProps.Tag;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    var imagePlaceholderStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded ? 0 : 1,
	      transitionDelay: "0.25s"
	    }, imgStyle);
	
	    var imageStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0
	    }, imgStyle);
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden"
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement(Tag, {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            style: imagePlaceholderStyle
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({ alt: alt, title: title }, image))
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            style: imagePlaceholderStyle
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({
	                alt: alt,
	                title: title,
	                width: _image.width,
	                height: _image.height
	              }, _image))
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: "",
	  Tag: "div"
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  imgStyle: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func,
	  Tag: _propTypes2.default.string
	};
	
	exports.default = Image;

/***/ }),

/***/ 151:
/***/ (function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	module.exports = function (obj) {
	  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
	}
	
	function isBuffer (obj) {
	  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer (obj) {
	  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
	}


/***/ }),

/***/ 984:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(1129);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(725);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(985);
	
	var _HelmetConstants = __webpack_require__(462);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 462:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 985:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(203);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(462);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 987:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(20);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaArrowDown = function FaArrowDown(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm37.5 18.6q0 1.2-0.9 2l-14.5 14.5q-0.9 0.9-2 0.9-1.2 0-2-0.9l-14.6-14.5q-0.8-0.8-0.8-2 0-1.2 0.8-2.1l1.7-1.6q0.9-0.9 2-0.9 1.2 0 2 0.9l6.6 6.5v-15.7q0-1.1 0.8-2t2-0.8h2.9q1.2 0 2 0.8t0.9 2v15.7l6.5-6.5q0.8-0.9 2-0.9 1.2 0 2.1 0.9l1.6 1.6q0.9 0.9 0.9 2.1z' })
	        )
	    );
	};
	
	exports.default = FaArrowDown;
	module.exports = exports['default'];

/***/ }),

/***/ 314:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(20);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaArrowRight = function FaArrowRight(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm36.4 21.4q0 1.2-0.9 2.1l-14.5 14.5q-0.9 0.8-2 0.8-1.2 0-2-0.8l-1.7-1.7q-0.9-0.8-0.9-2t0.9-2l6.5-6.6h-15.7q-1.1 0-1.9-0.8t-0.7-2v-2.9q0-1.2 0.7-2t1.9-0.9h15.7l-6.5-6.5q-0.9-0.8-0.9-2t0.9-2l1.7-1.7q0.8-0.9 2-0.9 1.2 0 2 0.9l14.5 14.5q0.9 0.8 0.9 2z' })
	        )
	    );
	};
	
	exports.default = FaArrowRight;
	module.exports = exports['default'];

/***/ }),

/***/ 315:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(20);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCalendar = function FaCalendar(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm4.4 37.1h6.4v-6.4h-6.4v6.4z m7.8 0h7.2v-6.4h-7.2v6.4z m-7.8-7.8h6.4v-7.2h-6.4v7.2z m7.8 0h7.2v-7.2h-7.2v7.2z m-7.8-8.6h6.4v-6.4h-6.4v6.4z m16.4 16.4h7.1v-6.4h-7.1v6.4z m-8.6-16.4h7.2v-6.4h-7.2v6.4z m17.2 16.4h6.4v-6.4h-6.4v6.4z m-8.6-7.8h7.1v-7.2h-7.1v7.2z m-7.9-19.3v-6.4q0-0.3-0.2-0.5t-0.5-0.2h-1.4q-0.3 0-0.5 0.2t-0.2 0.5v6.4q0 0.3 0.2 0.5t0.5 0.2h1.4q0.3 0 0.5-0.2t0.2-0.5z m16.5 19.3h6.4v-7.2h-6.4v7.2z m-8.6-8.6h7.1v-6.4h-7.1v6.4z m8.6 0h6.4v-6.4h-6.4v6.4z m0.7-10.7v-6.4q0-0.3-0.2-0.5t-0.5-0.2h-1.5q-0.3 0-0.5 0.2t-0.2 0.5v6.4q0 0.3 0.2 0.5t0.5 0.2h1.5q0.2 0 0.5-0.2t0.2-0.5z m8.5-1.4v28.5q0 1.2-0.8 2.1t-2 0.8h-31.4q-1.2 0-2.1-0.9t-0.8-2v-28.5q0-1.2 0.8-2t2.1-0.9h2.8v-2.1q0-1.5 1.1-2.6t2.5-1h1.4q1.5 0 2.5 1.1t1.1 2.5v2.1h8.6v-2.1q0-1.5 1-2.6t2.5-1h1.5q1.4 0 2.5 1.1t1 2.5v2.1h2.9q1.1 0 2 0.9t0.8 2z' })
	        )
	    );
	};
	
	exports.default = FaCalendar;
	module.exports = exports['default'];

/***/ }),

/***/ 1129:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(251));
	var shallowEqual = _interopDefault(__webpack_require__(1181));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 1181:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 564:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _style = __webpack_require__(11);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Item = __webpack_require__(565);
	
	var _Item2 = _interopRequireDefault(_Item);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Blog = function Blog(props) {
	  var posts = props.posts,
	      theme = props.theme;
	
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      "main",
	      {
	        className: _style2.default.dynamic([["3489809510", [theme.space.inset.default, "calc(" + theme.space.default + " * 1.5) 0 calc(" + theme.space.default + " * 0.5)", "0 calc(" + theme.space.default + " * 1.5)", theme.text.maxWidth.tablet, theme.text.maxWidth.desktop]]]) + " " + "main"
	      },
	      _react2.default.createElement(
	        "ul",
	        {
	          className: _style2.default.dynamic([["3489809510", [theme.space.inset.default, "calc(" + theme.space.default + " * 1.5) 0 calc(" + theme.space.default + " * 0.5)", "0 calc(" + theme.space.default + " * 1.5)", theme.text.maxWidth.tablet, theme.text.maxWidth.desktop]]])
	        },
	        posts.map(function (post) {
	          var node = post.node,
	              slug = post.node.fields.slug;
	
	          return _react2.default.createElement(_Item2.default, { key: slug, post: node, theme: theme });
	        })
	      )
	    ),
	    _react2.default.createElement(_style2.default, {
	      styleId: "3489809510",
	      css: [".main.__jsx-style-dynamic-selector{padding:0 " + theme.space.inset.default + ";}", "ul.__jsx-style-dynamic-selector{list-style:none;margin:0 auto;padding:" + ("calc(" + theme.space.default + " * 1.5) 0 calc(" + theme.space.default + " * 0.5)") + ";}", "@media screen and (min-width:601px){.main.__jsx-style-dynamic-selector{padding:0 " + ("0 calc(" + theme.space.default + " * 1.5)") + ";}ul.__jsx-style-dynamic-selector{max-width:" + theme.text.maxWidth.tablet + ";}}", "@media screen and (min-width:1025px){ul.__jsx-style-dynamic-selector{max-width:" + theme.text.maxWidth.desktop + ";}}"],
	      dynamic: [theme.space.inset.default, "calc(" + theme.space.default + " * 1.5) 0 calc(" + theme.space.default + " * 0.5)", "0 calc(" + theme.space.default + " * 1.5)", theme.text.maxWidth.tablet, theme.text.maxWidth.desktop]
	    })
	  );
	};
	
	Blog.propTypes = {
	  posts: _propTypes2.default.array.isRequired,
	  theme: _propTypes2.default.object.isRequired
	};
	
	exports.default = Blog;
	module.exports = exports["default"];

/***/ }),

/***/ 565:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _style = __webpack_require__(11);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _arrowRight = __webpack_require__(314);
	
	var _arrowRight2 = _interopRequireDefault(_arrowRight);
	
	var _calendar = __webpack_require__(315);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	var _tag = __webpack_require__(168);
	
	var _tag2 = _interopRequireDefault(_tag);
	
	var _user = __webpack_require__(316);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _gatsbyImage = __webpack_require__(753);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _gatsbyLink = __webpack_require__(42);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Item = function Item(props) {
	  var theme = props.theme,
	      _props$post = props.post,
	      excerpt = _props$post.excerpt,
	      _props$post$fields = _props$post.fields,
	      slug = _props$post$fields.slug,
	      prefix = _props$post$fields.prefix,
	      _props$post$frontmatt = _props$post.frontmatter,
	      title = _props$post$frontmatt.title,
	      category = _props$post$frontmatt.category,
	      author = _props$post$frontmatt.author,
	      _props$post$frontmatt2 = _props$post$frontmatt.cover.children,
	      sizes = _props$post$frontmatt2[0].sizes;
	
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      "li",
	      {
	        className: _style2.default.dynamic([["893077714", [theme.text.color.primary, theme.size.radius.default, "calc(" + theme.space.default + " * 2) 0 calc(" + theme.space.default + " * 3)", theme.space.inset.s, theme.time.duration.default, theme.size.radius.default, theme.line.color, theme.line.color, "calc(" + theme.space.default + " * -1.5)", theme.time.duration.default, theme.line.color, "calc(" + theme.space.default + " * -1.5)", theme.time.duration.default, theme.space.m, theme.space.s, theme.blog.h1.lineHeight, theme.blog.h1.size, theme.space.m, theme.space.s, theme.icon.color, theme.space.inline.xs, theme.space.xs, theme.space.s, theme.space.xs, theme.space.s, "calc(" + theme.space.default + " * 3) 0 calc(" + theme.space.default + " * 4)", theme.space.default, "calc(" + theme.space.default + " * -2)", "calc(" + theme.space.default + " * -1.75)", "calc(" + theme.blog.h1.size + " * 1.2)", "calc(" + theme.space.default + " * 1.5) " + theme.space.default + " 0", "calc(" + theme.space.m + " * 1.5) " + theme.space.m, theme.space.default, "calc(" + theme.space.default + " * 4) 0 calc(" + theme.space.default + " * 5)", "calc(" + theme.space.default + " * 2)", "calc(" + theme.space.default + " * -1.5)", "calc(" + theme.space.default + " * -2.75)", "calc(" + theme.space.default + " * -2.75)", "calc(" + theme.space.default + " * 1.2) calc(" + theme.space.default + " * 2) 0", "calc(" + theme.space.default + " * 1.5) calc(" + theme.space.default + " * 2)\n              calc(" + theme.space.default + " * 0.5)", "0 calc(" + theme.space.default + " * 2)", theme.line.color, "calc(" + theme.space.default + " * -2.5)", theme.time.duration.default, theme.blog.h1.hoverColor, theme.color.special.attention]]])
	      },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: slug, key: slug, className: "link" },
	        _react2.default.createElement(_gatsbyImage2.default, { sizes: sizes }),
	        _react2.default.createElement(
	          "h1",
	          {
	            className: _style2.default.dynamic([["893077714", [theme.text.color.primary, theme.size.radius.default, "calc(" + theme.space.default + " * 2) 0 calc(" + theme.space.default + " * 3)", theme.space.inset.s, theme.time.duration.default, theme.size.radius.default, theme.line.color, theme.line.color, "calc(" + theme.space.default + " * -1.5)", theme.time.duration.default, theme.line.color, "calc(" + theme.space.default + " * -1.5)", theme.time.duration.default, theme.space.m, theme.space.s, theme.blog.h1.lineHeight, theme.blog.h1.size, theme.space.m, theme.space.s, theme.icon.color, theme.space.inline.xs, theme.space.xs, theme.space.s, theme.space.xs, theme.space.s, "calc(" + theme.space.default + " * 3) 0 calc(" + theme.space.default + " * 4)", theme.space.default, "calc(" + theme.space.default + " * -2)", "calc(" + theme.space.default + " * -1.75)", "calc(" + theme.blog.h1.size + " * 1.2)", "calc(" + theme.space.default + " * 1.5) " + theme.space.default + " 0", "calc(" + theme.space.m + " * 1.5) " + theme.space.m, theme.space.default, "calc(" + theme.space.default + " * 4) 0 calc(" + theme.space.default + " * 5)", "calc(" + theme.space.default + " * 2)", "calc(" + theme.space.default + " * -1.5)", "calc(" + theme.space.default + " * -2.75)", "calc(" + theme.space.default + " * -2.75)", "calc(" + theme.space.default + " * 1.2) calc(" + theme.space.default + " * 2) 0", "calc(" + theme.space.default + " * 1.5) calc(" + theme.space.default + " * 2)\n              calc(" + theme.space.default + " * 0.5)", "0 calc(" + theme.space.default + " * 2)", theme.line.color, "calc(" + theme.space.default + " * -2.5)", theme.time.duration.default, theme.blog.h1.hoverColor, theme.color.special.attention]]])
	          },
	          title,
	          " ",
	          _react2.default.createElement(_arrowRight2.default, { className: "arrow" })
	        ),
	        _react2.default.createElement(
	          "p",
	          {
	            className: _style2.default.dynamic([["893077714", [theme.text.color.primary, theme.size.radius.default, "calc(" + theme.space.default + " * 2) 0 calc(" + theme.space.default + " * 3)", theme.space.inset.s, theme.time.duration.default, theme.size.radius.default, theme.line.color, theme.line.color, "calc(" + theme.space.default + " * -1.5)", theme.time.duration.default, theme.line.color, "calc(" + theme.space.default + " * -1.5)", theme.time.duration.default, theme.space.m, theme.space.s, theme.blog.h1.lineHeight, theme.blog.h1.size, theme.space.m, theme.space.s, theme.icon.color, theme.space.inline.xs, theme.space.xs, theme.space.s, theme.space.xs, theme.space.s, "calc(" + theme.space.default + " * 3) 0 calc(" + theme.space.default + " * 4)", theme.space.default, "calc(" + theme.space.default + " * -2)", "calc(" + theme.space.default + " * -1.75)", "calc(" + theme.blog.h1.size + " * 1.2)", "calc(" + theme.space.default + " * 1.5) " + theme.space.default + " 0", "calc(" + theme.space.m + " * 1.5) " + theme.space.m, theme.space.default, "calc(" + theme.space.default + " * 4) 0 calc(" + theme.space.default + " * 5)", "calc(" + theme.space.default + " * 2)", "calc(" + theme.space.default + " * -1.5)", "calc(" + theme.space.default + " * -2.75)", "calc(" + theme.space.default + " * -2.75)", "calc(" + theme.space.default + " * 1.2) calc(" + theme.space.default + " * 2) 0", "calc(" + theme.space.default + " * 1.5) calc(" + theme.space.default + " * 2)\n              calc(" + theme.space.default + " * 0.5)", "0 calc(" + theme.space.default + " * 2)", theme.line.color, "calc(" + theme.space.default + " * -2.5)", theme.time.duration.default, theme.blog.h1.hoverColor, theme.color.special.attention]]]) + " " + "meta"
	          },
	          _react2.default.createElement(
	            "span",
	            {
	              className: _style2.default.dynamic([["893077714", [theme.text.color.primary, theme.size.radius.default, "calc(" + theme.space.default + " * 2) 0 calc(" + theme.space.default + " * 3)", theme.space.inset.s, theme.time.duration.default, theme.size.radius.default, theme.line.color, theme.line.color, "calc(" + theme.space.default + " * -1.5)", theme.time.duration.default, theme.line.color, "calc(" + theme.space.default + " * -1.5)", theme.time.duration.default, theme.space.m, theme.space.s, theme.blog.h1.lineHeight, theme.blog.h1.size, theme.space.m, theme.space.s, theme.icon.color, theme.space.inline.xs, theme.space.xs, theme.space.s, theme.space.xs, theme.space.s, "calc(" + theme.space.default + " * 3) 0 calc(" + theme.space.default + " * 4)", theme.space.default, "calc(" + theme.space.default + " * -2)", "calc(" + theme.space.default + " * -1.75)", "calc(" + theme.blog.h1.size + " * 1.2)", "calc(" + theme.space.default + " * 1.5) " + theme.space.default + " 0", "calc(" + theme.space.m + " * 1.5) " + theme.space.m, theme.space.default, "calc(" + theme.space.default + " * 4) 0 calc(" + theme.space.default + " * 5)", "calc(" + theme.space.default + " * 2)", "calc(" + theme.space.default + " * -1.5)", "calc(" + theme.space.default + " * -2.75)", "calc(" + theme.space.default + " * -2.75)", "calc(" + theme.space.default + " * 1.2) calc(" + theme.space.default + " * 2) 0", "calc(" + theme.space.default + " * 1.5) calc(" + theme.space.default + " * 2)\n              calc(" + theme.space.default + " * 0.5)", "0 calc(" + theme.space.default + " * 2)", theme.line.color, "calc(" + theme.space.default + " * -2.5)", theme.time.duration.default, theme.blog.h1.hoverColor, theme.color.special.attention]]])
	            },
	            _react2.default.createElement(_calendar2.default, { size: 18 }),
	            " ",
	            prefix
	          ),
	          _react2.default.createElement(
	            "span",
	            {
	              className: _style2.default.dynamic([["893077714", [theme.text.color.primary, theme.size.radius.default, "calc(" + theme.space.default + " * 2) 0 calc(" + theme.space.default + " * 3)", theme.space.inset.s, theme.time.duration.default, theme.size.radius.default, theme.line.color, theme.line.color, "calc(" + theme.space.default + " * -1.5)", theme.time.duration.default, theme.line.color, "calc(" + theme.space.default + " * -1.5)", theme.time.duration.default, theme.space.m, theme.space.s, theme.blog.h1.lineHeight, theme.blog.h1.size, theme.space.m, theme.space.s, theme.icon.color, theme.space.inline.xs, theme.space.xs, theme.space.s, theme.space.xs, theme.space.s, "calc(" + theme.space.default + " * 3) 0 calc(" + theme.space.default + " * 4)", theme.space.default, "calc(" + theme.space.default + " * -2)", "calc(" + theme.space.default + " * -1.75)", "calc(" + theme.blog.h1.size + " * 1.2)", "calc(" + theme.space.default + " * 1.5) " + theme.space.default + " 0", "calc(" + theme.space.m + " * 1.5) " + theme.space.m, theme.space.default, "calc(" + theme.space.default + " * 4) 0 calc(" + theme.space.default + " * 5)", "calc(" + theme.space.default + " * 2)", "calc(" + theme.space.default + " * -1.5)", "calc(" + theme.space.default + " * -2.75)", "calc(" + theme.space.default + " * -2.75)", "calc(" + theme.space.default + " * 1.2) calc(" + theme.space.default + " * 2) 0", "calc(" + theme.space.default + " * 1.5) calc(" + theme.space.default + " * 2)\n              calc(" + theme.space.default + " * 0.5)", "0 calc(" + theme.space.default + " * 2)", theme.line.color, "calc(" + theme.space.default + " * -2.5)", theme.time.duration.default, theme.blog.h1.hoverColor, theme.color.special.attention]]])
	            },
	            _react2.default.createElement(_user2.default, { size: 18 }),
	            " ",
	            author
	          ),
	          category && _react2.default.createElement(
	            "span",
	            {
	              className: _style2.default.dynamic([["893077714", [theme.text.color.primary, theme.size.radius.default, "calc(" + theme.space.default + " * 2) 0 calc(" + theme.space.default + " * 3)", theme.space.inset.s, theme.time.duration.default, theme.size.radius.default, theme.line.color, theme.line.color, "calc(" + theme.space.default + " * -1.5)", theme.time.duration.default, theme.line.color, "calc(" + theme.space.default + " * -1.5)", theme.time.duration.default, theme.space.m, theme.space.s, theme.blog.h1.lineHeight, theme.blog.h1.size, theme.space.m, theme.space.s, theme.icon.color, theme.space.inline.xs, theme.space.xs, theme.space.s, theme.space.xs, theme.space.s, "calc(" + theme.space.default + " * 3) 0 calc(" + theme.space.default + " * 4)", theme.space.default, "calc(" + theme.space.default + " * -2)", "calc(" + theme.space.default + " * -1.75)", "calc(" + theme.blog.h1.size + " * 1.2)", "calc(" + theme.space.default + " * 1.5) " + theme.space.default + " 0", "calc(" + theme.space.m + " * 1.5) " + theme.space.m, theme.space.default, "calc(" + theme.space.default + " * 4) 0 calc(" + theme.space.default + " * 5)", "calc(" + theme.space.default + " * 2)", "calc(" + theme.space.default + " * -1.5)", "calc(" + theme.space.default + " * -2.75)", "calc(" + theme.space.default + " * -2.75)", "calc(" + theme.space.default + " * 1.2) calc(" + theme.space.default + " * 2) 0", "calc(" + theme.space.default + " * 1.5) calc(" + theme.space.default + " * 2)\n              calc(" + theme.space.default + " * 0.5)", "0 calc(" + theme.space.default + " * 2)", theme.line.color, "calc(" + theme.space.default + " * -2.5)", theme.time.duration.default, theme.blog.h1.hoverColor, theme.color.special.attention]]])
	            },
	            _react2.default.createElement(_tag2.default, { size: 18 }),
	            " ",
	            category
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          {
	            className: _style2.default.dynamic([["893077714", [theme.text.color.primary, theme.size.radius.default, "calc(" + theme.space.default + " * 2) 0 calc(" + theme.space.default + " * 3)", theme.space.inset.s, theme.time.duration.default, theme.size.radius.default, theme.line.color, theme.line.color, "calc(" + theme.space.default + " * -1.5)", theme.time.duration.default, theme.line.color, "calc(" + theme.space.default + " * -1.5)", theme.time.duration.default, theme.space.m, theme.space.s, theme.blog.h1.lineHeight, theme.blog.h1.size, theme.space.m, theme.space.s, theme.icon.color, theme.space.inline.xs, theme.space.xs, theme.space.s, theme.space.xs, theme.space.s, "calc(" + theme.space.default + " * 3) 0 calc(" + theme.space.default + " * 4)", theme.space.default, "calc(" + theme.space.default + " * -2)", "calc(" + theme.space.default + " * -1.75)", "calc(" + theme.blog.h1.size + " * 1.2)", "calc(" + theme.space.default + " * 1.5) " + theme.space.default + " 0", "calc(" + theme.space.m + " * 1.5) " + theme.space.m, theme.space.default, "calc(" + theme.space.default + " * 4) 0 calc(" + theme.space.default + " * 5)", "calc(" + theme.space.default + " * 2)", "calc(" + theme.space.default + " * -1.5)", "calc(" + theme.space.default + " * -2.75)", "calc(" + theme.space.default + " * -2.75)", "calc(" + theme.space.default + " * 1.2) calc(" + theme.space.default + " * 2) 0", "calc(" + theme.space.default + " * 1.5) calc(" + theme.space.default + " * 2)\n              calc(" + theme.space.default + " * 0.5)", "0 calc(" + theme.space.default + " * 2)", theme.line.color, "calc(" + theme.space.default + " * -2.5)", theme.time.duration.default, theme.blog.h1.hoverColor, theme.color.special.attention]]])
	          },
	          excerpt
	        )
	      )
	    ),
	    _react2.default.createElement(_style2.default, {
	      styleId: "893077714",
	      css: [".link{width:100%;color:" + theme.text.color.primary + ";}", "li.__jsx-style-dynamic-selector{border:1px solid transparent;border-radius:" + theme.size.radius.default + ";margin:" + ("calc(" + theme.space.default + " * 2) 0 calc(" + theme.space.default + " * 3)") + ";padding:" + theme.space.inset.s + ";position:relative;-webkit-transition:all " + theme.time.duration.default + ";-webkit-transition:all " + theme.time.duration.default + ";transition:all " + theme.time.duration.default + ";background:transparent;}", "li.__jsx-style-dynamic-selector .gatsby-image-outer-wrapper{border-radius:" + theme.size.radius.default + ";border:1px solid " + theme.line.color + ";overflow:hidden;}", "li.__jsx-style-dynamic-selector .gatsby-image-outer-wrapper img{z-index:-1;}", "li.__jsx-style-dynamic-selector:after{border-top:1px solid " + theme.line.color + ";content:\"\";height:0;position:absolute;bottom:" + ("calc(" + theme.space.default + " * -1.5)") + ";left:50%;-webkit-transform:translateX(-50%);-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%);-webkit-transition:all " + theme.time.duration.default + ";-webkit-transition:all " + theme.time.duration.default + ";transition:all " + theme.time.duration.default + ";width:50%;}", "li.__jsx-style-dynamic-selector:first-child.__jsx-style-dynamic-selector:before{border-top:1px solid " + theme.line.color + ";content:\"\";height:0;position:absolute;top:" + ("calc(" + theme.space.default + " * -1.5)") + ";left:50%;-webkit-transform:translateX(-50%);-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%);-webkit-transition:all " + theme.time.duration.default + ";-webkit-transition:all " + theme.time.duration.default + ";transition:all " + theme.time.duration.default + ";width:50%;}", "h1.__jsx-style-dynamic-selector{padding:" + theme.space.m + " " + theme.space.s + " 0;line-height:" + theme.blog.h1.lineHeight + ";font-size:" + theme.blog.h1.size + ";}", "h1.__jsx-style-dynamic-selector .arrow{display:none;}", "h1.__jsx-style-dynamic-selector:before{display:table;content:\"\";margin-bottom:-0.17em;}", "h1.__jsx-style-dynamic-selector:after{display:table;content:\"\";margin-top:-0.11em;}", ".meta.__jsx-style-dynamic-selector{display:-webkit-box;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;-webkit-flex-flow:row wrap;-ms-flex-flow:row wrap;flex-flow:row wrap;font-size:0.8em;padding:" + theme.space.m + " " + theme.space.s + ";background:transparent;}", ".meta.__jsx-style-dynamic-selector svg{fill:" + theme.icon.color + ";margin:" + theme.space.inline.xs + ";}", ".meta.__jsx-style-dynamic-selector span.__jsx-style-dynamic-selector{-webkit-box-align:center;-ms-flex-align:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;text-transform:uppercase;margin:" + theme.space.xs + " " + theme.space.s + " " + theme.space.xs + " 0;}", "p.__jsx-style-dynamic-selector{line-height:1.5;padding:0 " + theme.space.s + ";}", "p.__jsx-style-dynamic-selector:before{display:table;content:\"\";margin-bottom:-0.42em;}", "p.__jsx-style-dynamic-selector:after{display:table;content:\"\";margin-top:-0.36em;}", "@media screen and (min-width:600px){li.__jsx-style-dynamic-selector{margin:" + ("calc(" + theme.space.default + " * 3) 0 calc(" + theme.space.default + " * 4)") + ";padding:" + theme.space.default + ";}li.__jsx-style-dynamic-selector:after{bottom:" + ("calc(" + theme.space.default + " * -2)") + ";}li.__jsx-style-dynamic-selector:first-child.__jsx-style-dynamic-selector:before{top:" + ("calc(" + theme.space.default + " * -1.75)") + ";}h1.__jsx-style-dynamic-selector{font-size:" + ("calc(" + theme.blog.h1.size + " * 1.2)") + ";padding:" + ("calc(" + theme.space.default + " * 1.5) " + theme.space.default + " 0") + ";-webkit-transition:all 0.5s;-webkit-transition:all 0.5s;transition:all 0.5s;}.meta.__jsx-style-dynamic-selector{padding:" + ("calc(" + theme.space.m + " * 1.5) " + theme.space.m) + ";}p.__jsx-style-dynamic-selector{padding:0 " + theme.space.default + ";}}", "@media screen and (min-width:1024px){li.__jsx-style-dynamic-selector{margin:" + ("calc(" + theme.space.default + " * 4) 0 calc(" + theme.space.default + " * 5)") + ";padding:0 0 " + ("calc(" + theme.space.default + " * 2)") + ";}li.__jsx-style-dynamic-selector:after{bottom:" + ("calc(" + theme.space.default + " * -1.5)") + ";}li.__jsx-style-dynamic-selector:first-child.__jsx-style-dynamic-selector:before{top:" + ("calc(" + theme.space.default + " * -2.75)") + ";}.blogItemLink:first-child>li.__jsx-style-dynamic-selector:before{top:" + ("calc(" + theme.space.default + " * -2.75)") + ";}h1.__jsx-style-dynamic-selector{font-size:2.5em;padding:" + ("calc(" + theme.space.default + " * 1.2) calc(" + theme.space.default + " * 2) 0") + ";}.meta.__jsx-style-dynamic-selector{padding:" + ("calc(" + theme.space.default + " * 1.5) calc(" + theme.space.default + " * 2)\n              calc(" + theme.space.default + " * 0.5)") + ";}p.__jsx-style-dynamic-selector{padding:" + ("0 calc(" + theme.space.default + " * 2)") + ";}@media (hover:hover){li.__jsx-style-dynamic-selector:hover{border:1px solid " + theme.line.color + ";-webkit-box-shadow:0px 3px 2px rgba(0,0,0,.03);box-shadow:0px 3px 2px rgba(0,0,0,.03);}li.__jsx-style-dynamic-selector:hover.__jsx-style-dynamic-selector:after{bottom:" + ("calc(" + theme.space.default + " * -2.5)") + ";}li.__jsx-style-dynamic-selector:hover .gatsby-image-wrapper{-webkit-transform:scale(1.1);-webkit-transform:scale(1.1);-ms-transform:scale(1.1);transform:scale(1.1);-webkit-transition:all " + theme.time.duration.default + ";-webkit-transition:all " + theme.time.duration.default + ";transition:all " + theme.time.duration.default + ";}li.__jsx-style-dynamic-selector:hover h1.__jsx-style-dynamic-selector{color:" + theme.blog.h1.hoverColor + ";}li.__jsx-style-dynamic-selector:hover .arrow{opacity:1;-webkit-transform:translateX(0);-webkit-transform:translateX(0);-ms-transform:translateX(0);transform:translateX(0);}li.__jsx-style-dynamic-selector .arrow{display:inline-block;fill:" + theme.color.special.attention + ";opacity:0;-webkit-transition:all 0.5s;-webkit-transition:all 0.5s;transition:all 0.5s;-webkit-transform:translateX(-50%);-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%);}}}"],
	      dynamic: [theme.text.color.primary, theme.size.radius.default, "calc(" + theme.space.default + " * 2) 0 calc(" + theme.space.default + " * 3)", theme.space.inset.s, theme.time.duration.default, theme.size.radius.default, theme.line.color, theme.line.color, "calc(" + theme.space.default + " * -1.5)", theme.time.duration.default, theme.line.color, "calc(" + theme.space.default + " * -1.5)", theme.time.duration.default, theme.space.m, theme.space.s, theme.blog.h1.lineHeight, theme.blog.h1.size, theme.space.m, theme.space.s, theme.icon.color, theme.space.inline.xs, theme.space.xs, theme.space.s, theme.space.xs, theme.space.s, "calc(" + theme.space.default + " * 3) 0 calc(" + theme.space.default + " * 4)", theme.space.default, "calc(" + theme.space.default + " * -2)", "calc(" + theme.space.default + " * -1.75)", "calc(" + theme.blog.h1.size + " * 1.2)", "calc(" + theme.space.default + " * 1.5) " + theme.space.default + " 0", "calc(" + theme.space.m + " * 1.5) " + theme.space.m, theme.space.default, "calc(" + theme.space.default + " * 4) 0 calc(" + theme.space.default + " * 5)", "calc(" + theme.space.default + " * 2)", "calc(" + theme.space.default + " * -1.5)", "calc(" + theme.space.default + " * -2.75)", "calc(" + theme.space.default + " * -2.75)", "calc(" + theme.space.default + " * 1.2) calc(" + theme.space.default + " * 2) 0", "calc(" + theme.space.default + " * 1.5) calc(" + theme.space.default + " * 2)\n              calc(" + theme.space.default + " * 0.5)", "0 calc(" + theme.space.default + " * 2)", theme.line.color, "calc(" + theme.space.default + " * -2.5)", theme.time.duration.default, theme.blog.h1.hoverColor, theme.color.special.attention]
	    })
	  );
	};
	
	Item.propTypes = {
	  post: _propTypes2.default.object.isRequired,
	  theme: _propTypes2.default.object.isRequired
	};
	
	exports.default = Item;
	module.exports = exports["default"];

/***/ }),

/***/ 566:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Blog = __webpack_require__(564);
	
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Blog).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports["default"];

/***/ }),

/***/ 575:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _style = __webpack_require__(11);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _arrowDown = __webpack_require__(987);
	
	var _arrowDown2 = _interopRequireDefault(_arrowDown);
	
	var _spotifyAuth = __webpack_require__(58);
	
	var _spotifyApi = __webpack_require__(138);
	
	var _window = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Hero = function (_React$Component) {
	  _inherits(Hero, _React$Component);
	
	  function Hero() {
	    _classCallCheck(this, Hero);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.state = {
	      logged_in_spotify: (0, _spotifyAuth.isSpotifyAccessTokenValid)(),
	      spotifyProfile: null
	    };
	    return _this;
	  }
	
	  Hero.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    if ((0, _spotifyAuth.isSpotifyAccessTokenValid)()) {
	      (0, _spotifyApi.getMe)().then(function (response) {
	        _this2.setState({ spotifyProfile: response, logged_in_spotify: true });
	      });
	    }
	  };
	
	  Hero.prototype.render = function render() {
	    var _props = this.props,
	        scrollToContent = _props.scrollToContent,
	        backgrounds = _props.backgrounds,
	        theme = _props.theme;
	    var _state = this.state,
	        logged_in_spotify = _state.logged_in_spotify,
	        spotifyProfile = _state.spotifyProfile;
	
	    var spotifyDisplayName = spotifyProfile ? spotifyProfile.display_name : '';
	    var showContinue = logged_in_spotify && spotifyDisplayName;
	
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        "section",
	        {
	          className: _style2.default.dynamic([["1281255417", [theme.hero.background, backgrounds.mobile, theme.text.color.primary.inverse, theme.space.inset.l, theme.header.height.homepage, "calc(" + theme.hero.h1.size + " * .8)", theme.space.stack.l, theme.hero.h1.color, theme.hero.h1.lineHeight, theme.text.color.attention, theme.space.xs, theme.space.s, theme.color.neutral.gray.k, theme.space.xs, theme.color.spotify_green, theme.background.color.brand, theme.font.size.m, theme.space.s, theme.space.m, theme.color.brand.primary.active, theme.color.neutral.white, theme.time.duration.long, backgrounds.tablet, "calc(" + theme.hero.h1.size + " * 1.1)", theme.font.size.l, backgrounds.desktop, "calc(" + theme.hero.h1.size + " * 1.5)", theme.font.size.xl]]]) + " " + "hero"
	        },
	        _react2.default.createElement(
	          "h1",
	          {
	            className: _style2.default.dynamic([["1281255417", [theme.hero.background, backgrounds.mobile, theme.text.color.primary.inverse, theme.space.inset.l, theme.header.height.homepage, "calc(" + theme.hero.h1.size + " * .8)", theme.space.stack.l, theme.hero.h1.color, theme.hero.h1.lineHeight, theme.text.color.attention, theme.space.xs, theme.space.s, theme.color.neutral.gray.k, theme.space.xs, theme.color.spotify_green, theme.background.color.brand, theme.font.size.m, theme.space.s, theme.space.m, theme.color.brand.primary.active, theme.color.neutral.white, theme.time.duration.long, backgrounds.tablet, "calc(" + theme.hero.h1.size + " * 1.1)", theme.font.size.l, backgrounds.desktop, "calc(" + theme.hero.h1.size + " * 1.5)", theme.font.size.xl]]])
	          },
	          "Convert your Spotify Playlists to YouTube."
	        ),
	        showContinue && _react2.default.createElement(
	          "div",
	          {
	            className: _style2.default.dynamic([["1281255417", [theme.hero.background, backgrounds.mobile, theme.text.color.primary.inverse, theme.space.inset.l, theme.header.height.homepage, "calc(" + theme.hero.h1.size + " * .8)", theme.space.stack.l, theme.hero.h1.color, theme.hero.h1.lineHeight, theme.text.color.attention, theme.space.xs, theme.space.s, theme.color.neutral.gray.k, theme.space.xs, theme.color.spotify_green, theme.background.color.brand, theme.font.size.m, theme.space.s, theme.space.m, theme.color.brand.primary.active, theme.color.neutral.white, theme.time.duration.long, backgrounds.tablet, "calc(" + theme.hero.h1.size + " * 1.1)", theme.font.size.l, backgrounds.desktop, "calc(" + theme.hero.h1.size + " * 1.5)", theme.font.size.xl]]])
	          },
	          _react2.default.createElement(
	            "button",
	            { onClick: function onClick() {
	                return (0, _window.setNewLocation)('/converter');
	              }, className: _style2.default.dynamic([["1281255417", [theme.hero.background, backgrounds.mobile, theme.text.color.primary.inverse, theme.space.inset.l, theme.header.height.homepage, "calc(" + theme.hero.h1.size + " * .8)", theme.space.stack.l, theme.hero.h1.color, theme.hero.h1.lineHeight, theme.text.color.attention, theme.space.xs, theme.space.s, theme.color.neutral.gray.k, theme.space.xs, theme.color.spotify_green, theme.background.color.brand, theme.font.size.m, theme.space.s, theme.space.m, theme.color.brand.primary.active, theme.color.neutral.white, theme.time.duration.long, backgrounds.tablet, "calc(" + theme.hero.h1.size + " * 1.1)", theme.font.size.l, backgrounds.desktop, "calc(" + theme.hero.h1.size + " * 1.5)", theme.font.size.xl]]]) + " " + "spotify-login"
	            },
	            "Continue as Spotify User - ",
	            spotifyDisplayName
	          ),
	          _react2.default.createElement("br", {
	            className: _style2.default.dynamic([["1281255417", [theme.hero.background, backgrounds.mobile, theme.text.color.primary.inverse, theme.space.inset.l, theme.header.height.homepage, "calc(" + theme.hero.h1.size + " * .8)", theme.space.stack.l, theme.hero.h1.color, theme.hero.h1.lineHeight, theme.text.color.attention, theme.space.xs, theme.space.s, theme.color.neutral.gray.k, theme.space.xs, theme.color.spotify_green, theme.background.color.brand, theme.font.size.m, theme.space.s, theme.space.m, theme.color.brand.primary.active, theme.color.neutral.white, theme.time.duration.long, backgrounds.tablet, "calc(" + theme.hero.h1.size + " * 1.1)", theme.font.size.l, backgrounds.desktop, "calc(" + theme.hero.h1.size + " * 1.5)", theme.font.size.xl]]])
	          }),
	          _react2.default.createElement(
	            "button",
	            { onClick: function onClick() {
	                return (0, _spotifyAuth.logoutOfSpotifyAndRedirectToHome)();
	              }, className: _style2.default.dynamic([["1281255417", [theme.hero.background, backgrounds.mobile, theme.text.color.primary.inverse, theme.space.inset.l, theme.header.height.homepage, "calc(" + theme.hero.h1.size + " * .8)", theme.space.stack.l, theme.hero.h1.color, theme.hero.h1.lineHeight, theme.text.color.attention, theme.space.xs, theme.space.s, theme.color.neutral.gray.k, theme.space.xs, theme.color.spotify_green, theme.background.color.brand, theme.font.size.m, theme.space.s, theme.space.m, theme.color.brand.primary.active, theme.color.neutral.white, theme.time.duration.long, backgrounds.tablet, "calc(" + theme.hero.h1.size + " * 1.1)", theme.font.size.l, backgrounds.desktop, "calc(" + theme.hero.h1.size + " * 1.5)", theme.font.size.xl]]]) + " " + "spotify-login"
	            },
	            "Logout"
	          )
	        ),
	        !showContinue && _react2.default.createElement(
	          "button",
	          { onClick: function onClick() {
	              return (0, _spotifyAuth.authSpotify)(false);
	            }, className: _style2.default.dynamic([["1281255417", [theme.hero.background, backgrounds.mobile, theme.text.color.primary.inverse, theme.space.inset.l, theme.header.height.homepage, "calc(" + theme.hero.h1.size + " * .8)", theme.space.stack.l, theme.hero.h1.color, theme.hero.h1.lineHeight, theme.text.color.attention, theme.space.xs, theme.space.s, theme.color.neutral.gray.k, theme.space.xs, theme.color.spotify_green, theme.background.color.brand, theme.font.size.m, theme.space.s, theme.space.m, theme.color.brand.primary.active, theme.color.neutral.white, theme.time.duration.long, backgrounds.tablet, "calc(" + theme.hero.h1.size + " * 1.1)", theme.font.size.l, backgrounds.desktop, "calc(" + theme.hero.h1.size + " * 1.5)", theme.font.size.xl]]]) + " " + "spotify-login"
	          },
	          "Login to Spotify"
	        ),
	        _react2.default.createElement(
	          "button",
	          { onClick: scrollToContent, "aria-label": "scroll", className: _style2.default.dynamic([["1281255417", [theme.hero.background, backgrounds.mobile, theme.text.color.primary.inverse, theme.space.inset.l, theme.header.height.homepage, "calc(" + theme.hero.h1.size + " * .8)", theme.space.stack.l, theme.hero.h1.color, theme.hero.h1.lineHeight, theme.text.color.attention, theme.space.xs, theme.space.s, theme.color.neutral.gray.k, theme.space.xs, theme.color.spotify_green, theme.background.color.brand, theme.font.size.m, theme.space.s, theme.space.m, theme.color.brand.primary.active, theme.color.neutral.white, theme.time.duration.long, backgrounds.tablet, "calc(" + theme.hero.h1.size + " * 1.1)", theme.font.size.l, backgrounds.desktop, "calc(" + theme.hero.h1.size + " * 1.5)", theme.font.size.xl]]]) + " " + "scroll-to-content"
	          },
	          _react2.default.createElement(_arrowDown2.default, null),
	          _react2.default.createElement(
	            "span",
	            {
	              className: _style2.default.dynamic([["1281255417", [theme.hero.background, backgrounds.mobile, theme.text.color.primary.inverse, theme.space.inset.l, theme.header.height.homepage, "calc(" + theme.hero.h1.size + " * .8)", theme.space.stack.l, theme.hero.h1.color, theme.hero.h1.lineHeight, theme.text.color.attention, theme.space.xs, theme.space.s, theme.color.neutral.gray.k, theme.space.xs, theme.color.spotify_green, theme.background.color.brand, theme.font.size.m, theme.space.s, theme.space.m, theme.color.brand.primary.active, theme.color.neutral.white, theme.time.duration.long, backgrounds.tablet, "calc(" + theme.hero.h1.size + " * 1.1)", theme.font.size.l, backgrounds.desktop, "calc(" + theme.hero.h1.size + " * 1.5)", theme.font.size.xl]]]) + " " + "scroll-to-content-text"
	            },
	            "Check out our music video blog!"
	          ),
	          _react2.default.createElement(_arrowDown2.default, null)
	        )
	      ),
	      _react2.default.createElement(_style2.default, {
	        styleId: "1281255417",
	        css: [".hero.__jsx-style-dynamic-selector{-webkit-box-align:center;-ms-flex-align:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:" + theme.hero.background + ";background-image:url(" + backgrounds.mobile + ");background-size:cover;color:" + theme.text.color.primary.inverse + ";display:-webkit-box;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column nowrap;-webkit-flex-flow:column nowrap;-ms-flex-flow:column nowrap;flex-flow:column nowrap;-webkit-box-pack:center;-ms-flex-pack:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;min-height:650px;height:100vh;padding:" + theme.space.inset.l + ";padding-top:" + theme.header.height.homepage + ";}", "h1.__jsx-style-dynamic-selector{text-align:center;font-size:" + ("calc(" + theme.hero.h1.size + " * .8)") + ";margin:" + theme.space.stack.l + ";color:" + theme.hero.h1.color + ";line-height:" + theme.hero.h1.lineHeight + ";}", "h1.__jsx-style-dynamic-selector strong{position:relative;}", "h1.__jsx-style-dynamic-selector strong:after,h1.__jsx-style-dynamic-selector strong:before{content:\"\u203A\";color:" + theme.text.color.attention + ";margin:0 " + theme.space.xs + " 0 0;text-shadow:0 0 " + theme.space.s + " " + theme.color.neutral.gray.k + ";}", "h1.__jsx-style-dynamic-selector strong:after{content:\"\u2039\";margin:0 0 0 " + theme.space.xs + ";}", "h1.__jsx-style-dynamic-selector:before{display:table;content:\"\";margin-bottom:-0.17em;}", "h1.__jsx-style-dynamic-selector:after{display:table;content:\"\";margin-top:-0.11em;}", "button.spotify-login.__jsx-style-dynamic-selector{background:" + theme.color.spotify_green + ";color:white;border-radius:50px;width:500px;max-width:100vw;min-height:60px;margin-bottom:20px;}", "button.scroll-to-content.__jsx-style-dynamic-selector{background:black;color:white;border-radius:50px;font-size:1em;margin-top:20px;max-width:500px;min-height:50px;width:100vw;}", "button.scroll-to-content.__jsx-style-dynamic-selector .scroll-to-content-text.__jsx-style-dynamic-selector{color:white;margin:0 15px;}", "button.__jsx-style-dynamic-selector{background:" + theme.background.color.brand + ";border:0;font-size:" + theme.font.size.m + ";padding:" + theme.space.s + " " + theme.space.m + ";cursor:pointer;}", "button.__jsx-style-dynamic-selector:focus{outline-style:none;background:" + theme.color.brand.primary.active + ";}", "button.__jsx-style-dynamic-selector svg{fill:" + theme.color.neutral.white + ";-webkit-animation-duration:" + theme.time.duration.long + ";-webkit-animation-duration:" + theme.time.duration.long + ";animation-duration:" + theme.time.duration.long + ";-webkit-animation-name:buttonIconMove;-webkit-animation-name:buttonIconMove-__jsx-style-dynamic-selector;animation-name:buttonIconMove-__jsx-style-dynamic-selector;-webkit-animation-iteration-count:infinite;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;}", "@-webkit-keyframes buttonIconMove{0%.__jsx-style-dynamic-selector{-webkit-transform:translateY(0);-webkit-transform:translateY(0);-ms-transform:translateY(0);transform:translateY(0);}50%.__jsx-style-dynamic-selector{-webkit-transform:translateY(-10px);-webkit-transform:translateY(-10px);-ms-transform:translateY(-10px);transform:translateY(-10px);}100%.__jsx-style-dynamic-selector{-webkit-transform:translateY(0);-webkit-transform:translateY(0);-ms-transform:translateY(0);transform:translateY(0);}}", "@-webkit-keyframes buttonIconMove-__jsx-style-dynamic-selector{0%{-webkit-transform:translateY(0);-webkit-transform:translateY(0);-ms-transform:translateY(0);transform:translateY(0);}50%{-webkit-transform:translateY(-10px);-webkit-transform:translateY(-10px);-ms-transform:translateY(-10px);transform:translateY(-10px);}100%{-webkit-transform:translateY(0);-webkit-transform:translateY(0);-ms-transform:translateY(0);transform:translateY(0);}}", "@keyframes buttonIconMove-__jsx-style-dynamic-selector{0%{-webkit-transform:translateY(0);-webkit-transform:translateY(0);-ms-transform:translateY(0);transform:translateY(0);}50%{-webkit-transform:translateY(-10px);-webkit-transform:translateY(-10px);-ms-transform:translateY(-10px);transform:translateY(-10px);}100%{-webkit-transform:translateY(0);-webkit-transform:translateY(0);-ms-transform:translateY(0);transform:translateY(0);}}", "@media screen and (min-width:600px){.hero.__jsx-style-dynamic-selector{background-image:url(" + backgrounds.tablet + ");}h1.__jsx-style-dynamic-selector{max-width:90%;font-size:" + ("calc(" + theme.hero.h1.size + " * 1.1)") + ";}button.__jsx-style-dynamic-selector{font-size:" + theme.font.size.l + ";}button.scroll-to-content.__jsx-style-dynamic-selector{width:400px;margin-top:100px;}}", "@media screen and (min-width:1024px){.hero.__jsx-style-dynamic-selector{background-image:url(" + backgrounds.desktop + ");}h1.__jsx-style-dynamic-selector{max-width:80%;font-size:" + ("calc(" + theme.hero.h1.size + " * 1.5)") + ";}button.__jsx-style-dynamic-selector{font-size:" + theme.font.size.xl + ";}}"],
	        dynamic: [theme.hero.background, backgrounds.mobile, theme.text.color.primary.inverse, theme.space.inset.l, theme.header.height.homepage, "calc(" + theme.hero.h1.size + " * .8)", theme.space.stack.l, theme.hero.h1.color, theme.hero.h1.lineHeight, theme.text.color.attention, theme.space.xs, theme.space.s, theme.color.neutral.gray.k, theme.space.xs, theme.color.spotify_green, theme.background.color.brand, theme.font.size.m, theme.space.s, theme.space.m, theme.color.brand.primary.active, theme.color.neutral.white, theme.time.duration.long, backgrounds.tablet, "calc(" + theme.hero.h1.size + " * 1.1)", theme.font.size.l, backgrounds.desktop, "calc(" + theme.hero.h1.size + " * 1.5)", theme.font.size.xl]
	      })
	    );
	  };
	
	  return Hero;
	}(_react2.default.Component);
	
	;
	
	Hero.propTypes = {
	  scrollToContent: _propTypes2.default.func.isRequired,
	  backgrounds: _propTypes2.default.object.isRequired,
	  theme: _propTypes2.default.object.isRequired
	};
	
	exports.default = Hero;
	module.exports = exports["default"];

/***/ }),

/***/ 576:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Hero = __webpack_require__(575);
	
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Hero).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports["default"];

/***/ }),

/***/ 600:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(984);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _config = __webpack_require__(136);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Seo = function Seo(props) {
	  var data = props.data,
	      facebook = props.facebook;
	
	  var postTitle = ((data || {}).frontmatter || {}).title;
	  var postDescription = ((data || {}).frontmatter || {}).description;
	  var postCover = ((data || {}).frontmatter || {}).cover;
	  var postSlug = ((data || {}).fields || {}).slug;
	
	  var title = postTitle ? postTitle + " - " + _config2.default.shortSiteTitle : _config2.default.siteTitle;
	  var description = postDescription ? postDescription : _config2.default.siteDescription;
	  var image = postCover ? postCover : _config2.default.siteImage;
	  var url = _config2.default.siteUrl + _config2.default.pathPrefix + postSlug;
	
	  return _react2.default.createElement(
	    _reactHelmet2.default,
	    {
	      htmlAttributes: {
	        lang: _config2.default.siteLanguage,
	        prefix: "og: http://ogp.me/ns#"
	      }
	    },
	    _react2.default.createElement(
	      "title",
	      null,
	      title
	    ),
	    _react2.default.createElement("meta", { name: "google-site-verification", content: "W_yHl2j5e7uArKV8Lh3t2D3CVxzKDRKQUr46FQsZf_Y" }),
	    _react2.default.createElement("meta", { name: "description", content: description }),
	    _react2.default.createElement("meta", { property: "og:url", content: url }),
	    _react2.default.createElement("meta", { property: "og:title", content: title }),
	    _react2.default.createElement("meta", { property: "og:description", content: description }),
	    _react2.default.createElement("meta", { property: "og:image", content: image }),
	    _react2.default.createElement("meta", { property: "og:type", content: "website" }),
	    _react2.default.createElement("meta", { property: "fb:app_id", content: facebook.appId }),
	    _react2.default.createElement("meta", { name: "twitter:card", content: "summary" }),
	    _react2.default.createElement("meta", {
	      name: "twitter:creator",
	      content: _config2.default.authorTwitterAccount ? _config2.default.authorTwitterAccount : ""
	    })
	  );
	};
	
	Seo.propTypes = {
	  data: _propTypes2.default.object,
	  facebook: _propTypes2.default.object.isRequired
	};
	
	exports.default = Seo;
	module.exports = exports["default"];

/***/ }),

/***/ 601:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Seo = __webpack_require__(600);
	
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Seo).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports["default"];

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getPlaylistTracks = exports.getMyPlaylists = exports.getMe = undefined;
	
	var _axios = __webpack_require__(98);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _spotifyAuth = __webpack_require__(58);
	
	var _window = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var spotifyAxios = _axios2.default.create({
	  baseURL: 'https://api.spotify.com/v1',
	  timeout: 1000
	});
	
	var setAccessToken = function setAccessToken() {
	  if (!(0, _spotifyAuth.isSpotifyAccessTokenValid)()) {
	    (0, _window.setNewLocation)('/spotifyauth');
	    return false;
	  }
	  // Check if access token is valid first and redirect if not
	  var access_token = (0, _spotifyAuth.getSpotifyAccessToken)();
	
	  spotifyAxios.defaults.headers.common['Authorization'] = "Bearer " + access_token;
	  return true;
	};
	
	var getMe = function getMe() {
	  if (!setAccessToken()) {
	    return Promise.reject({ error: 'Invalid token' });
	  }
	
	  var access_token = (0, _spotifyAuth.getSpotifyAccessToken)();
	  var profileFromLocalStorage = getSpotifyProfile(access_token);
	
	  if (profileFromLocalStorage) {
	    return Promise.resolve(profileFromLocalStorage);
	  }
	
	  return spotifyAxios.get('/me').then(function (response) {
	    var _setSpotifyProfile;
	
	    var data = response.data;
	    var has_image = data.images && data.images.length > 0;
	    var image_url = has_image ? data.images[0].url : null;
	
	    var profile = {
	      display_name: data.display_name,
	      spotify_open_url: data.external_urls ? data.external_urls.spotify : '',
	      image_url: image_url,
	      id: data.id
	    };
	
	    setSpotifyProfile((_setSpotifyProfile = {}, _setSpotifyProfile[access_token] = profile, _setSpotifyProfile));
	
	    return profile;
	  }).catch(function (error) {
	    return {
	      error: "Failed to load profile. Try again."
	    };
	  });
	};
	
	// Consider a caching strategy
	var getMyPlaylists = function getMyPlaylists() {
	  if (!setAccessToken()) {
	    return Promise.reject({ error: 'Invalid token' });
	  }
	
	  var access_token = (0, _spotifyAuth.getSpotifyAccessToken)();
	
	  return new Promise(function (resolve, reject) {
	    getMyPlaylistsNext([], '/me/playlists?limit=50', resolve, reject, 0);
	  });
	};
	
	var getMyPlaylistsNext = function getMyPlaylistsNext(playlists, next, resolve, reject, retries) {
	  if (next) {
	    spotifyAxios.get(next).then(function (response) {
	      var _response$data = response.data,
	          items = _response$data.items,
	          next = _response$data.next;
	
	
	      var bareItems = items.map(function (item) {
	        return { playlistId: item.id, playlistName: item.name, songCount: item.tracks.total, ownerId: item.owner.id };
	      });
	      playlists = playlists.concat(bareItems); // can filter down what I need
	      getMyPlaylistsNext(playlists, next, resolve, reject);
	    }, function () {
	      if (retries < 2) {
	        getMyPlaylistsNext(playlists, next, resolve, reject, retries + 1);
	      } else {
	        alert('Failed to load Spotify playlists after several retries - please refresh the page or report the issue to playlistbuddy.app@gmail.com');
	        reject();
	      }
	    });
	  } else {
	    resolve({ playlists: playlists });
	  }
	};
	
	// GET https://api.spotify.com/v1/me/tracks USERS tracks
	
	// Would be nice to trim down the artist object to only name
	var getPlaylistTracks = function getPlaylistTracks(_ref) {
	  var ownerId = _ref.ownerId,
	      playlistId = _ref.playlistId;
	
	  if (!setAccessToken()) {
	    return Promise.reject({ error: 'Invalid token' });
	  }
	
	  var access_token = (0, _spotifyAuth.getSpotifyAccessToken)();
	
	  return new Promise(function (resolve, reject) {
	    getPlaylistTracksNext([], "users/" + ownerId + "/playlists/" + playlistId + "/tracks?limit=100&fields=next,items(track(name,album(name),artists,preview_url,popularity,duration_ms))", resolve, reject, 0);
	  });
	};
	
	var convertToMinutesSeconds = function convertToMinutesSeconds(ms) {
	  var minutes = Math.floor(ms / 60000);
	  var seconds = (ms % 60000 / 1000).toFixed(0);
	  return minutes + ":" + (seconds < 10 ? '0' : '') + seconds;
	};
	
	// Figure out how to cancel if long playlist is being loaded and use clicks away
	var getPlaylistTracksNext = function getPlaylistTracksNext(tracks, next, resolve, reject, retries) {
	  if (next) {
	    spotifyAxios.get(next).then(function (response) {
	      var _response$data2 = response.data,
	          items = _response$data2.items,
	          next = _response$data2.next;
	
	
	      var bareItems = items.map(function (item) {
	        var track = item.track;
	        var artistName = track.artists.map(function (artist) {
	          return artist.name;
	        }).join(', ');
	
	        return {
	          songName: track.name,
	          artistName: artistName,
	          albumName: track.album.name,
	          popularity: track.popularity,
	          preview: track.preview_url,
	          duration: convertToMinutesSeconds(track.duration_ms)
	        };
	      });
	
	      tracks = tracks.concat(bareItems);
	      getPlaylistTracksNext(tracks, next, resolve, reject);
	    }, function () {
	      if (retries < 3) {
	        getPlaylistTracksNext(tracks, next, resolve, reject, retries + 1);
	      } else {
	        alert('Failed to load Spotify playlist after several retries - please refresh the page or report the issue to playlistbuddy.app@gmail.com');
	        reject();
	      }
	    });
	  } else {
	    // Implement some sort of caching with snapshot_id
	    resolve({ tracks: tracks });
	  }
	};
	
	var getSpotifyProfile = function getSpotifyProfile(access_token) {
	  var profile = JSON.parse((0, _window.localStorageGet)('PB_SPOTIFY_PROFILE') || '{}');
	
	  return profile[access_token];
	};
	
	var setSpotifyProfile = function setSpotifyProfile(profile) {
	  return (0, _window.localStorageSet)('PB_SPOTIFY_PROFILE', JSON.stringify(profile));
	};
	
	exports.getMe = getMe;
	exports.getMyPlaylists = getMyPlaylists;
	exports.getPlaylistTracks = getPlaylistTracks;

/***/ }),

/***/ 608:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.guery = undefined;
	
	var _style = __webpack_require__(11);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _layouts = __webpack_require__(48);
	
	var _Blog = __webpack_require__(566);
	
	var _Blog2 = _interopRequireDefault(_Blog);
	
	var _Hero = __webpack_require__(576);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _Seo = __webpack_require__(601);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexPage = function (_React$Component) {
	  _inherits(IndexPage, _React$Component);
	
	  function IndexPage() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, IndexPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.separator = _react2.default.createRef(), _this.scrollToContent = function (e) {
	      _this.separator.current.scrollIntoView({ block: "start", behavior: "smooth" });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  IndexPage.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props$data = this.props.data,
	        _props$data$posts$edg = _props$data.posts.edges,
	        posts = _props$data$posts$edg === undefined ? [] : _props$data$posts$edg,
	        desktop = _props$data.bgDesktop.resize.src,
	        tablet = _props$data.bgTablet.resize.src,
	        mobile = _props$data.bgMobile.resize.src,
	        facebook = _props$data.site.siteMetadata.facebook;
	
	
	    var backgrounds = {
	      desktop: desktop,
	      tablet: tablet,
	      mobile: mobile
	    };
	
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        _layouts.ThemeContext.Consumer,
	        null,
	        function (theme) {
	          return _react2.default.createElement(_Hero2.default, { scrollToContent: _this2.scrollToContent, backgrounds: backgrounds, theme: theme });
	        }
	      ),
	      _react2.default.createElement("hr", { ref: this.separator, className: "jsx-311820556"
	      }),
	      _react2.default.createElement(
	        _layouts.ThemeContext.Consumer,
	        null,
	        function (theme) {
	          return _react2.default.createElement(_Blog2.default, { posts: posts, theme: theme });
	        }
	      ),
	      _react2.default.createElement(_Seo2.default, { facebook: facebook }),
	      _react2.default.createElement(_style2.default, {
	        styleId: "311820556",
	        css: ["hr.jsx-311820556{margin:0;border:0;}"]
	      })
	    );
	  };
	
	  return IndexPage;
	}(_react2.default.Component);
	
	IndexPage.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	
	exports.default = IndexPage;
	
	//eslint-disable-next-line no-undef
	
	var guery = exports.guery = "** extracted graphql fragment **";
	
	//hero-background

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-532bc80b3ff354275f7c.js